<div class="container">
    <div class="row">
        <div class="col-lg-12">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                    <li class="breadcrumb-item"><a [routerLink]="['/Maintenance']">Mantenimiento</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">{{entityName}}</li>
                </ol>
            </nav>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-5">
            <h4>{{entityName}}</h4>
            <p>{{entityDescription}}</p>
        </div>
        <div class="col-lg-7">
            <p-toolbar>
                <div class="ui-toolbar-group-left">
                </div>
                <div class="ui-toolbar-group-right d-md-none  d-lg-none d-xl-none actionButtons">
                    <button pButton type="button" [disabled]="buttonDisabled" (click)="onEdit();" icon="pi pi-pencil"
                        class="p-button-success toolButtonMin"></button>
                </div>
                <div class="ui-toolbar-group-right d-none d-sm-none  d-md-block d-lg-block actionButtons">
                    <button pButton type="button" label="Editar" [disabled]="buttonDisabled" (click)="onEdit();"
                        icon="pi pi-pencil" class="p-button-success toolButton"></button>
                </div>
            </p-toolbar>
        </div>
    </div>
    <div class="row">
        <form [formGroup]="organizationForm" class="formClass boxed" (ngSubmit)="onSubmit();">
            <input type="hidden" name="id" formControlName="id">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="name" class="required">Nombre:</label>
                        <input type="text" class="form-control" formControlName="name"
                            placeholder="Ingrese el nombre de la organizacion"
                            [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['name'].errors }">
                        <div *ngIf="organizationSubmitted && organizationControls['name'].errors"
                            class="invalid-feedback">
                            <div *ngIf="organizationControls['name'].errors['required']">El nombre es requerido.</div>
                        </div>
                    </div>
                    <div class="form-group" *ngIf="isPhysicalPerson">
                        <label for="lastName" class="required">Apellido:</label>
                        <input type="text" class="form-control" formControlName="lastName"
                            placeholder="Ingrese el apellido"
                            [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['lastName'].errors }">
                    </div>
                    <div class="form-group">
                        <label for="personTypeId" class="required">Tipo de Identificaci&oacute;n:</label>
                        <select placeholder="Seleccione el tipo de identificaci&oacute;n" formControlName="personTypeId"
                            class="form-control"
                            [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['personTypeId'].errors }"
                            (change)="onPersonTypeChange($any($event.target).value)">
                            <option *ngFor="let personType of personTypes" [value]="personType.id">{{personType.name}}
                            </option>
                        </select>
                        <div *ngIf="organizationSubmitted && organizationControls['personTypeId'].errors"
                            class="invalid-feedback">
                            <div *ngIf="organizationControls['personTypeId'].errors['required']">El tipo de
                                identificaci&oacute;n
                                es requerido.
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="identification" class="required">Identificaci&oacute;n:</label>
                        <input type="text" class="form-control" formControlName="identification"
                            placeholder="Ingrese el numero de identificaci&oacute;n"
                            [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['identification'].errors }">
                        <div *ngIf="organizationSubmitted && organizationControls['identification'].errors"
                            class="invalid-feedback">
                            <div *ngIf="organizationControls['identification'].errors['required']">El numero de
                                identificaci&oacute;n es
                                requerido.</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="comercialName" class="required">Nombre comercial:</label>
                        <input type="text" class="form-control" formControlName="comercialName"
                            placeholder="Ingrese el nombre comercial"
                            [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['comercialName'].errors }">
                    </div>
                    <div class="form-group">
                        <label for="emailAddress" class="required">Correo electr&oacute;nico:</label>
                        <input type="text" class="form-control" formControlName="emailAddress"
                            placeholder="Ingrese el correo electr&oacute;nico"
                            [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['emailAddress'].errors }">
                        <div *ngIf="organizationSubmitted && organizationControls['emailAddress'].errors"
                            class="invalid-feedback">
                            <div *ngIf="organizationControls['emailAddress'].errors['required']">El correo es requerido.
                            </div>
                            <div *ngIf="organizationControls['emailAddress'].errors['email']">Formato de correo
                                inv&aacute;lido.
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="phoneNumber1" class="required">Tel&eacute;fono:</label>
                        <input type="text" class="form-control" formControlName="phoneNumber1"
                            placeholder="Ingrese el n&uacute;mero de tel&eacute;fono" mask="(000) 0000-0000"
                            [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['phoneNumber1'].errors }">
                        <div *ngIf="organizationSubmitted && organizationControls['phoneNumber1'].errors"
                            class="invalid-feedback">
                            <div *ngIf="organizationControls['phoneNumber1'].errors['required']">El tel&eacute;fono es
                                requerido.
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="economicActivityId" class="required">Actividad econ&oacute;mica:</label>
                        <select placeholder="Seleccione la actividad econ&oacute;mica"
                            formControlName="economicActivityId" class="form-control"
                            [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['economicActivityId'].errors }">
                            <option *ngFor="let activities of economicActivities" [ngValue]="activities.Id">
                                {{activities.Name}}</option>
                        </select>
                        <div *ngIf="organizationSubmitted && organizationControls['economicActivityId'].errors"
                            class="invalid-feedback">
                            <div *ngIf="organizationControls['economicActivityId'].errors['required']">La actividad
                                econ&oacute;mica es
                                requerida.
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="countryId" class="required">Pa&iacute;s:</label>
                        <select placeholder="Seleccione el pa&iacute;s" formControlName="countryId" class="form-control"
                            (change)="onSelectCountry($any($event.target).value)"
                            [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['countryId'].errors }">
                            <option *ngFor="let country of countries" [value]="country.Id">{{country.Name}}</option>
                        </select>
                        <div *ngIf="organizationSubmitted && organizationControls['countryId'].errors"
                            class="invalid-feedback">
                            <div *ngIf="organizationControls['countryId'].errors['required']">El pa&iacute;s es
                                requerido.
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="stateId" class="required">Provincia:</label>
                        <select placeholder="Seleccione la provincia" formControlName="stateId" class="form-control"
                            (change)="onSelectState($any($event.target).value)"
                            [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['stateId'].errors }">
                            <option *ngFor="let state of states" [ngValue]="state.Id">{{state.Name}}</option>
                        </select>
                        <div *ngIf="organizationSubmitted && organizationControls['stateId'].errors"
                            class="invalid-feedback">
                            <div *ngIf="organizationControls['stateId'].errors['required']">La provincia es requerida.
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="cityId" class="required">Cant&oacute;n:</label>
                        <select placeholder="Seleccione el cant&oacute;n" formControlName="cityId" class="form-control"
                            (change)="onSelectCity($any($event.target).value)"
                            [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['cityId'].errors }">
                            <option *ngFor="let city of cities" [ngValue]="city.Id">{{city.Name}}</option>
                        </select>
                        <div *ngIf="organizationSubmitted && organizationControls['cityId'].errors"
                            class="invalid-feedback">
                            <div *ngIf="organizationControls['cityId'].errors['required']">El cant&oacute;n es
                                requerido.
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="districtId" class="required">Distrito:</label>
                        <select placeholder="Seleccione el distrito" formControlName="districtId" class="form-control"
                            (change)="onSelectDistrict($any($event.target).value)"
                            [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['districtId'].errors }">
                            <option *ngFor="let district of districts" [ngValue]="district.Id">{{district.Name}}
                            </option>
                        </select>
                        <div *ngIf="organizationSubmitted && organizationControls['districtId'].errors"
                            class="invalid-feedback">
                            <div *ngIf="organizationControls['districtId'].errors['required']"> El distrito es
                                requerido.
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="neighborhoodId" class="required">Barrio:</label>
                        <select placeholder="Seleccione el barrio" formControlName="neighborhoodId" class="form-control"
                            (change)="onSelectDistrict($any($event.target).value)"
                            [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['neighborhoodId'].errors }">
                            <option *ngFor="let neighborhood of nighboorhoods" [ngValue]="neighborhood.Id">
                                {{neighborhood.Name}}</option>
                        </select>
                        <div *ngIf="organizationSubmitted && organizationControls['neighborhoodId'].errors"
                            class="invalid-feedback">
                            <div *ngIf="organizationControls['neighborhoodId'].errors['required']"> El barrio es
                                requerido.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">

                    <div class="form-group">
                        <label for="address">Direcci&oacute;n:</label>
                        <textarea class="form-control" formControlName="address" rows="3"
                            placeholder="Ingrese la direcci&oacute;n"
                            [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['address'].errors }"></textarea>
                        <div *ngIf="organizationSubmitted && organizationControls['address'].errors"
                            class="invalid-feedback">
                            <div *ngIf="organizationControls['address'].errors['required']">La direcci&oacute;n es
                                requerida.
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="imageURL">Imagen:</label><br>
                        <img [src]="imageFile" *ngIf="imageFile" class="rounded mx-auto d-block"
                            style="max-width: 50%;">
                    </div>
                    <div class="form-group">
                        <input type="file" #file id="inputFile" name="inputFile" accept='image/*' style="display:none;"
                            (change)="onFileChange(file.files)" />
                        <div class="text-center">
                            <input type="text" placeholder="Seleccione la imagen" class="form-control imageURL"
                                formControlName="imageURL" [attr.disabled]="'disabled'" style="visibility: hidden;">
                            <button pButton type="button" label="Seleccionar" (click)="onSearchImage();"
                                [disabled]="!buttonDisabled"></button>&nbsp;
                            <button pButton type="button" label="Eliminar" (click)="onClearImage();"
                                [disabled]="!buttonDisabled" class="ui-button-danger toolButton"></button>
                        </div>
                        <div *ngIf="imageMessage" class="text-danger">
                            {{imageMessage}}
                        </div>
                    </div>
                    <div class="input-group">
                        <div class="form-group">
                            <label for="isActive">
                                <input type="checkbox" formControlName="isActive" class="checkbox"> Activo:
                            </label>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row">
                <div class="col-12 col-md-6 text-center">
                    <button type="submit" class="btn btn-primary btn-block"
                        [disabled]="!buttonDisabled">Guardar</button>
                    <button type="button" class="btn btn-secondary btn-block" [disabled]="!buttonDisabled"
                        (click)="onCancel();">Cancelar</button>
                </div>
                <div class="col-12 col-md-6">
                </div>
            </div>
        </form>
    </div>
</div>